var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.084 6.56l4.484 1.943a.91.91 0 001.245-.605A6.367 6.367 0 007.632 0H7.62a.906.906 0 00-.884 1.055l.813 4.82c.05.304.253.562.535.686z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.18 10.57a.307.307 0 00-.137-.439s0 0 0 0L6.569 8.126s0 0 0 0h0l4.61 2.445zm0 0a5.774 5.774 0 01-4.57 2.58l4.57-2.58zM5.7 7.023h0l.91 6.128A5.77 5.77 0 01.822 5.802V5.8a5.766 5.766 0 013.582-3.84.308.308 0 01.406.236h0V2.2l.89 4.822z",
    stroke: "#979797",
    strokeWidth: 1.2
  })));
}
export default SvgReports;